import { useQuery } from "react-query";
import { getNavigationData } from "./service";

export const useNavigationData = (instance) => {
  return useQuery(
    "navigationData",
    async () => {
      const response = await getNavigationData(instance);
      return response;
    },
    {
      refetchInterval: 4 * 60 * 60 * 1000,
      staleTime: 4 * 60 * 60 * 1000,
    }
  );
};
